import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerSW } from 'virtual:pwa-register';
import { CartProvider } from './context/CartContext';
import { ImageProvider } from './context/ImageContext';
import App from './App.tsx';
import './index.css';

// Early capture of beforeinstallprompt so mobile browsers never drop it
if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    (window as unknown as { deferredPWAInstallPrompt?: Event }).deferredPWAInstallPrompt = e;
  });
}

// In development, ensure any stale dev service workers are completely unregistered
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const reg of registrations) {
      if (import.meta.env.DEV || reg.active?.scriptURL?.includes('dev-sw')) {
        reg.unregister().catch(() => {});
      }
    }
  }).catch(() => {});
}

// Only register production service worker in production builds
if (import.meta.env.PROD) {
  const updateSW = registerSW({
    immediate: true,
    onNeedRefresh() {
      updateSW(true);
    },
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ImageProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </ImageProvider>
    </BrowserRouter>
  </StrictMode>,
);
